<div id="content">
     <div class="overlay" *ngIf="loading">
          <h1 class="heading" [innerHtml]="'Loading' | translator:'base'">Loading...</h1>
     </div>
     <span *ngIf="translatedWebContent">
          <section *ngIf="!loading && webContent && translatedWebContent" class="bg-light" id="main">
               <div class="container">
                    <div class="row">
                         <div class="col-12">
                              <div *ngIf="previewItemId" class="alert alert-warning" role="alert">
                                   <h2>Preview Mode</h2>
                              </div>
                              <img class="w-100 d-block rounded-2 border border-primary mb-3"
                                   src="assets/content/css/images/drivers-hero.jpg"
                                   alt="Group of people in front of row of trucks." />
                              <h1 class="text-center" [innerHTML]="getHeading()">
                              </h1>
                              <span *ngFor="let subHeading of translatedWebContent.pageSubHeadings"
                                   [innerHtml]="subHeading.htmlContent"></span>
                         </div>
                    </div>
                    <div class="row">
                         <div class="col-lg-8 mb-32">
                              <div class="card shadow-sm rounded-2 border-0 h-100">
                                   <div class="card-body p-0">
                                        <ul ngbNav #nav="ngbNav" [(activeId)]="active" class="nav-tabs nav-fill">
                                             <li [ngbNavItem]="1">
                                                  <button ngbNavLink [innerHTML]="translatedWebContent.voicesHeading"
                                                       tabindex="0"></button>
                                                  <ng-template ngbNavContent>
                                                       <h3 class="card-title text-brand-dark h5"
                                                            [innerHtml]="translatedWebContent.voicesHeading"></h3>
                                                       <span
                                                            *ngFor="let voicesArticle of translatedWebContent.voicesItems">
                                                            <div class="row">
                                                                 <div class="col-12"
                                                                      [innerHtml]="voicesArticle.htmlContent"></div>
                                                            </div>
                                                            <hr class="my-4">
                                                       </span>
                                                  </ng-template>
                                             </li>
                                             <li [ngbNavItem]="2">
                                                  <button ngbNavLink [innerHtml]="'Resources' | translator:'base'"
                                                       tabindex="0">Resources</button>
                                                  <ng-template ngbNavContent>
                                                       <h3 class="card-title text-brand-dark h5"
                                                            [innerHtml]="'Resources' | translator:'base'">
                                                            Resources
                                                       </h3>

                                                       <div class="row">
                                                            <div class="col-12">
                                                                 <ul class="list-group border rounded-0 mb-3">
                                                                      <li class="list-group-item"
                                                                           *ngFor="let resourcesArticle of translatedWebContent.resourcesItems"
                                                                           [innerHtml]="resourcesArticle.htmlContent">
                                                                      </li>
                                                                 </ul>
                                                            </div>
                                                       </div>
                                                  </ng-template>
                                             </li>
                                        </ul>
                                        <div [ngbNavOutlet]="nav" class="py-3 px-4"></div>
                                   </div>
                              </div>
                         </div>
                         <div class="col-lg-4 mb-32">
                              <div
                                   class="card text-white shadow-sm d-flex align-items-stretch border-0 rounded-2 bg-brand-dark h-100">
                                   <div class="card-body">
                                        <h2 class="text-white card-title h3"
                                             [innerHtml]="'welcomeBack' | translator:'base'">Welcome Back</h2>
                                        <p>
                                             <span [innerHtml]="'welcome_box_1' | translator:'base'">Multi-factor
                                                  authentication is now required to access PSP</span>
                                        </p>
                                        <p>
                                             <span [innerHtml]="'welcome_box_2' | translator:'base'">
                                                  By clicking the LOGIN button, you will be redirected to the
                                             </span>
                                             <span [innerHtml]="'welcome_box_3' | translator:'base'">
                                                  From here, you can create an account, log in, or reset your password.
                                             </span>
                                        </p>
                                        <div>
                                             <p class="d-flex align-items-center mb-1">
                                                  <i class="fa-solid fa-circle-play me-2" style="padding-top: 3px;"
                                                       aria-hidden="true"></i>
                                                  <a href="https://tylertech.wistia.com/medias/0xrwx6huvz"
                                                       target="_blank" id="linkForgotPassword" name="linkForgotPassword"
                                                       [title]="'NeedHelp' | translator:'base'"
                                                       [innerHtml]="'NeedHelp' | translator:'base'">
                                                       Forgot your password?
                                                  </a>
                                             </p>
                                             <p class="d-flex m-0">
                                                  <i class="fa-solid fa-circle-play me-2" style="padding-top: 3px;"
                                                       aria-hidden="true"></i>
                                                  <a href="https://tylertech.wistia.com/medias/b1lzvgj3hb"
                                                       target="_blank" [innerHtml]="'PasswordVideo' | translator:'base'"
                                                       [attr.aria-label]="'PasswordVideoTitle' | translator:'base'"
                                                       [title]="'PasswordVideoTitle' | translator:'base'"
                                                       id="forgotPwdVideo" name="forgotPwdVideo">
                                                       Need help Creating your Login.gov Account?
                                                  </a>
                                             </p>
                                        </div>
                                        <div class="form-group d-flex mb-0 pt-4">
                                             <button (click)="redirectToLoginGov()" type="button" id="loginSubmit"
                                                  name="loginSubmit" class="btn btn-light btn-strong rounded-0 me-2"
                                                  [innerHtml]="'navbar_login_link' | translator:'base'"
                                                  [title]="'navbar_login_link' | translator:'base'">Login
                                             </button>
                                        </div>
                                   </div>
                                   <div class="card-footer"></div>
                              </div>
                         </div>
                    </div>
                    <div class="row d-flex align-items-stretch">
                         <div class="col-lg-4">
                              <div class="card shadow-sm rounded-2 border-0 h-100">
                                   <img class="card-img-top w-100 d-block rounded-top-2"
                                        src="assets/content/css/images/card-landing-01.jpg" alt="Commercial Driver" />
                                   <div class="card-body">
                                        <h2 class="card-title h5"
                                             [innerHtml]="'driver_what_psp_card_title' | translator:'driver'">What is a
                                             PSP
                                             Record?</h2>
                                        <p class="card-text">
                                             <span [innerHtml]="'driver_what_psp_card' | translator:'driver'">
                                                  Commercial
                                                  drivers' safety histories are collected by the Federal Motor Carrier
                                                  Safety
                                                  Administration (FMCSA). This data is placed into a convenient report
                                                  called
                                                  a PSP record. PSP records contain a commercial driver's 5-year crash
                                                  and
                                                  3-year inspection history. The PSP record does not contain a score.
                                                  The
                                                  information can be obtained for free by filing a Privacy Act request
                                                  from
                                                  the U.S. Department of Transportation.
                                             </span>
                                        </p>
                                   </div>
                                   <div class="card-footer bg-white">
                                        <button routerLink="/FAQ" class="btn btn-primary btn-strong" name="linkFAQ"
                                             id="linkFAQ" (click)="scrollToTop()"
                                             [innerHtml]="'HomeVeteransLink' | translator:'veterans'"
                                             [title]="'HomeVeteransLink' | translator:'veterans'" role="button">
                                             Learn More
                                        </button>
                                   </div>
                              </div>
                         </div>
                         <div class="col-lg-4">
                              <div class="card shadow-sm rounded-2 border-0 h-100">
                                   <img class="card-img-top w-100 d-block rounded-top-2"
                                        src="assets/content/css/images/card-landing-02.jpg"
                                        alt="Man and woman with Mobile Device" />
                                   <div class="card-body">
                                        <h2 class="card-title text-brand-dark h5"
                                             [innerHtml]="'Online_PSP_card_title' | translator:'veterans'">
                                             Online PSP Record Requests
                                        </h2>
                                        <p class="card-text">
                                             <span [innerHtml]="'Online_PSP_card_1' | translator:'veterans'">
                                                  PSP is an easy-to-use online service. PSP records are returned
                                                  immediately
                                                  in a PDF format
                                                  that is convenient for printing or saving. Single records cost $10 and
                                                  are
                                                  available 24 hours a day. To make an online PSP record request you
                                                  will
                                                  need
                                                  your current driver's license number, a credit card, and a valid email
                                                  address.
                                                  Haven't enrolled yet? The process is simple.
                                             </span>
                                             <button routerLink="/driver/1" (click)="scrollToTop()" type="button"
                                                  class="btn btn-link"
                                                  [innerHtml]="'Online_PSP_card_2' | translator:'veterans'"
                                                  [title]="'Online_PSP_card_2' | translator:'veterans'">
                                                  Click here
                                             </button>
                                             <span [innerHtml]="'Online_PSP_card_3' | translator:'veterans'"> to get
                                                  started!</span>
                                        </p>
                                   </div>
                                   <div class="card-footer bg-white">
                                        <button routerLink="/driver/1" (click.native)="scrollToTop()"
                                             class="btn btn-primary btn-strong" id="linkRequestRecords"
                                             name="linkRequestRecords"
                                             [innerHtml]="'RequestYourRec' | translator:'base'"
                                             [title]="'RequestYourRec' | translator:'base'" role="button">Request Your
                                             Record</button>
                                   </div>
                              </div>
                         </div>
                         <div class="col-lg-4">
                              <div class="card shadow-sm rounded-2 border-0 h-100">
                                   <img class="card-img-top w-100 d-block rounded-top-2"
                                        src="assets/content/css/images/card-banner-03.jpg"
                                        alt="Man with Mobile Devices" />
                                   <div class="card-body">
                                        <h2 class="card-title text-brand-dark h5"
                                             [innerHtml]="'WhatIsMonitoring' | translator:'driver'">What is PSP
                                             Monitoring?
                                        </h2>
                                        <p class="card-text" [innerHtml]="'home_what_card' | translator:'base'">PSP
                                             Monitoring is an
                                             optional new service that automatically informs drivers when their PSP data
                                             changes. Drivers who subscribe for the free monitoring service will receive
                                             an
                                             email each time their PSP record changes. This PSP monitoring service is
                                             offered
                                             free of charge and is for use by drivers only. To enroll you will need to
                                             log
                                             into PSP and go to the Driver Dashboard, then click on Enroll in PSP
                                             Monitoring.
                                        </p>
                                   </div>
                                   <div class="card-footer bg-white">
                                        <button routerLink="/driver/1/subscribe" (click.native)="scrollToTop()"
                                             type="button" id="loginSubmitWhatIsMonitoring"
                                             name="loginSubmitWhatIsMonitoring" class="btn btn-primary btn-strong"
                                             [innerHtml]="'driver_subscribe' | translator:'base'"
                                             [title]="'driver_subscribe' | translator:'base'">Subscribe</button>
                                   </div>
                              </div>
                         </div>
                    </div>
               </div>
          </section>
          <section class="text-white bg-brand" id="help-footer">
               <div class="container">
                    <div class="row d-flex align-items-center">
                         <div class="col-lg-8">
                              <h2 class="text-white h4">Need Assistance?</h2>
                              <p class="mb-0">
                                   <span class="contact-us-subheading">Do you have any questions about accessing a PSP
                                        record
                                        or wish to enroll in the program? We are happy to help!</span>&nbsp;
                                   <span [innerHtml]="'ContactUsHelpText' | translator:'base'">
                                        The PSP customer service team is available Monday through Thursday from 8 AM to
                                        6 PM ET, and on Friday from 8 AM to
                                        5 PM ET. To chat with an online representative, click the "LIVE HELP" button in
                                        the top-right corner of this page.
                                        You can also email us at <a href="mailto:PSPhelp@tylertech.com\"
                                             title="PSPhelp@tylertech.com">PSPhelp&#64;tylertech.com</a> or call us
                                        toll-free at <a href="tel:1-877-642-9499"
                                             title="1-877-642-9499">1-877-642-9499</a>.
                                   </span>
                              </p>
                         </div>
                         <div class="col-lg-4 py-3">
                              <p>
                                   <a 
                                        href="https://x.com/PSP_help"
                                        class="btn btn-light btn-block d-flex justify-content-center align-items-center btn-brand"
                                        target="_blank" 
                                        aria-label="PSP on X" 
                                        title="PSP X">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="fab bi bi-twitter-x me-2" viewBox="0 0 16 16">
                                             <path d="M12.6.75h2.454l-5.36 6.142L16 15.25h-4.937l-3.867-5.07-4.425 5.07H.316l5.733-6.57L0 .75h5.063l3.495 4.633L12.601.75Zm-.86 13.028h1.36L4.323 2.145H2.865z"/>
                                        </svg>
                                   </a>
                              </p>
                              <p class="mb-0">
                                   <a href="https://www.facebook.com/FMCSA/"
                                        class="btn btn-light btn-block d-flex justify-content-center align-items-center btn-brand"
                                        target="_blank" 
                                        aria-label="FMCSA Facebook" 
                                        title="FMCSA Facebook">
                                        <i class="fab fa-facebook me-2"></i>Facebook
                                   </a>
                              </p>
                         </div>
                    </div>
               </div>
          </section>
          <section class="text-white bg-brand" id="dataQs-footer" name="dataQs-footer">
               <div class="container">
                    <div class="row d-flex align-items-center">
                         <div class="col-lg-8">
                              <h2 class="text-white h4">Have Questions Regarding the Accuracy of a Driver Record?</h2>
                              <p class="mb-0">
                                   Do you have questions regarding the accuracy of a driver record and/or believe your
                                   PSP
                                   record
                                   is incorrect or
                                   incomplete, the FMCSA’s DataQ’s team can help. The DataQs system assists users
                                   including,
                                   motor
                                   carriers, drivers and
                                   their representatives in improving the accuracy of data provided by the FMCSA's
                                   data-driven
                                   safety systems. To get
                                   started, just click on the Create a DataQs account button to be taken to the official
                                   FMCSA
                                   DataQ’s page.
                              </p>
                         </div>
                         <div class="col-lg-4 py-3">
                              <p>
                                   <a href="https://dataqs.fmcsa.dot.gov/"
                                        class="btn btn-light btn-block d-flex justify-content-center align-items-center btn-brand"
                                        target="_blank" aria-label="Create a DataQs Account link" id="dataQs"
                                        name="dataQs" title="DataQs">
                                        <i class="fa fa-link me-2"></i>Create a DataQs Account
                                   </a>
                              </p>
                         </div>
                    </div>
               </div>
          </section>
     </span>
</div>